import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-group-cell',
  templateUrl: './group-cell.component.html',
  styleUrls: ['./group-cell.component.css']
})
export class GroupCellComponent implements ICellRendererAngularComp {
  public value: any = ''

  agInit(params: any): void {
    this.value = params?.value ?? ''
  }

  refresh(params: any): boolean {
    this.value = params?.value ?? ''
    return true
  }
}
